<template>
    <div>
        <!-- super sale  -->
        <template v-if="!loading">
            <div class="col-9 m-auto skeleton-body skel-shop-products">
                <template>
                    <div
                        class="skel-pro skel-pro-list"
                        v-for="item in 1"
                        :key="item"
                    ></div>
                </template>
            </div>
        </template>
        <div class="" v-else>
            <section
                v-for="banner in banners.seventh"
                :key="banner.id"
                class="super-sale"
                v-lazy:background-image="banner.background_image"
            >
                <div class="super-sale-holder">
                    <div class="container">
                        <div class="holder p-5 p">
                            
                            <h2 class="h1 hug text-white" >
                                {{ banner.title }}
                            </h2>
                            <!-- <h2 class="h1 hug text-white">50% OFF</h2> -->
                            
                            <p
                                class="text-dark"
                                
                            >
                                {{ banner.description }}
                            </p>
                            <div class="my-5">
                                <nuxt-link
                                    :to="localePath('/shop/sidebar/list')"
                                    class="btn toyButton text-white"
                                >
                                    <span>Order Now</span>
                                </nuxt-link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Repository, { baseUrl } from '~/repositories/repository.js';

export default {
    data: function () {
        return {
            banners: {
                first: [],
                seconnd: [],
                third: [],
                fourth: [],
                fifth: [],
                sixth: [],
                seventh: [],
            },
            loading: false,
        };
    },
    methods: {
        getData: async function () {
            let banners = `${baseUrl}/banners`;
            // banners
            await Repository.get(banners).then((resp) => {
                //banners
                if (resp.data.code == 200) {
                    this.loading = true;
                }
                this.banners = resp.data.banners;
                // console.log('banners', this.banners);
            });
        },
    },
    mounted() {
        this.getData();
    },
    props: ['product'],
};
</script>

<style>
</style>